import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';

// Third-party styles MUST load first, in one place only, so that
// component-level SCSS (imported deeper in the App tree) always
// comes later in the bundle and can override Bootstrap/PrimeReact
// defaults like .form-control.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import './styles/index.scss';
import App from './App';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// PrimeReact 10 reads its runtime config (ripple, z-index, overlay
// behaviour) from PrimeReactContext. Without this provider, overlay
// components such as column-filter menus and Dropdowns crash on
// scroll/resize while reading context.hideOverlaysOnDocumentScrolling.
const primeReactConfig = {
  ripple: true,
  hideOverlaysOnDocumentScrolling: false,
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider value={primeReactConfig}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>
);
